<template>
  <div ref="cardRoot" class="qr-card">
    <div class="qr-header">
      <div class="qr-bank">
        <div class="qr-bank-title">{{ bankNameUpper }}</div>
        <div class="qr-store">{{ displayStoreName }}</div>
      </div>
    </div>

    <div class="qr-body">
      <div class="qr-amount">{{ amount | NumberFormat }}</div>

      <div class="qr-panel">
        <div class="qr-lapnet">
          {{ $t("payment_via") }} LAPNet<br />{{ $t("lao_qr_pay") }}
        </div>
        <!-- QR Code Image -->
        <div class="qr-qr">
          <div class="qr-qr-wrapper">
            <img :src="qrImage" alt="QR Code" class="qr-qr-image" />
            <div class="qr-qr-overlay">
              <img
                src="/images/lao_qr.png"
                alt="Lao QR"
                class="qr-lao-qr-overlay"
                @error="handleLaoQRError"
              />
            </div>
          </div>
        </div>

        <div class="qr-merchant">
          <div class="qr-merchant-la">
            {{ $t("store_info") }}: {{ merchantLao }}
          </div>
        </div>
      </div>

      <div class="qr-bill">
        <div>{{ $t("ticket_number") }}: {{ ticketId }}</div>
        <div>{{ $t("amount") }}: {{ amount | NumberFormat }}</div>
      </div>
    </div>

    <!-- date and time -->
    <div class="qr-footer">
      {{ new Date().toLocaleString() }}
    </div>
  </div>
</template>

<script>
import { myMixin } from "@/mixin/main";
export default {
  name: "PaymentQRCard",
  mixins: [myMixin],
  props: {
    storeName: { type: String, default: "" },
    amount: { type: [Number, String], default: 0 },
    ticketId: { type: String, default: "" },
    qrImage: { type: String, required: true },
    merchantName: { type: String, default: "" },
    merchantId: { type: String, default: "" },
    bankName: { type: String, default: "PosSmart" },
  },
  computed: {
    displayStoreName() {
      return this.storeName || this.merchantName || "IT TEST";
    },
    merchantLao() {
      // If you have Lao merchant name, pass via props; otherwise fallback
      return this.displayStoreName;
    },
    bankNameUpper() {
      return (this.bankName || "PosSmart").toUpperCase();
    },
  },
  methods: {
    async downloadAsImage(filename = "payment-qr.png") {
      await this.ensureHtml2canvas();
      const html2canvas = window.html2canvas;
      const canvas = await html2canvas(this.$refs.cardRoot, {
        useCORS: true,
        backgroundColor: null,
        scale: 2,
      });
      const url = canvas.toDataURL("image/png");
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    ensureHtml2canvas() {
      return new Promise((resolve, reject) => {
        if (window.html2canvas) return resolve();
        const s = document.createElement("script");
        s.src =
          "https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js";
        s.async = true;
        s.onload = () => resolve();
        s.onerror = (e) => reject(e);
        document.head.appendChild(s);
      });
    },

    handleLaoQRError() {
      console.error("Lao QR image failed to load. Using a placeholder.");
    },
  },
};
</script>

<style scoped>
.qr-card {
  width: 420px;
  border-radius: 18px;
  background: #fff;
  overflow: hidden;
  border: 1px solid #e3e3e3;
  font-family: -apple-system, BlinkMacSystemFont, "Noto Sans Lao", "Sarabun",
    sans-serif;
  color: #2d2d2d;
}
.qr-header {
  background: #5b39aa;
  padding: 18px 20px 16px 20px;
  color: #fff;
}
.qr-bank-title {
  font-weight: 800;
  letter-spacing: 0.5px;
}
.qr-store {
  margin-top: 8px;
  font-size: 18px;
  font-weight: 700;
}
.qr-body {
  padding: 18px 18px 6px 18px;
}
.qr-amount-label {
  color: #7b7b7b;
  text-align: center;
}
.qr-amount {
  font-size: 28px;
  color: #5b39c9;
  font-weight: 800;
  text-align: center;
  margin: 6px 0 12px 0;
}
.qr-panel {
  border: 3px solid #5b39c9;
  border-radius: 10px;
  padding: 12px 12px 16px 12px;
}
.qr-lapnet {
  text-align: center;
  color: #5b39c9;
  font-weight: 700;
}
.qr-qr {
  height: 260px;
  width: 260px;
  margin: 12px auto;
  background: #fff;
  border: 2px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-qr-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* QR Wrapper and Overlay Styles */
.qr-qr-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-qr-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.qr-lao-qr-overlay {
  width: 25px;
  height: 25px;
  object-fit: contain;
  background-color: #fff;
  border-radius: 4px;
  padding: 4px;
}
.qr-merchant {
  margin-top: 4px;
  text-align: center;
}
.qr-merchant-la {
  font-weight: 700;
}
.qr-merchant-en,
.qr-merchant-id {
  color: #333;
}
.qr-bill {
  margin-top: 14px;
}
.qr-bill > div {
  margin: 2px 0;
}
.qr-footer {
  text-align: center;
  color: #8a8a8a;
  font-size: 12px;
  padding: 8px 0 12px 0;
}
</style>
